import { IMAGES } from "./images";



export const COURSE_CONFIG_SIX = [
  {
    id: 1,
    badge:"popular",
    image:"",
    course:"java full stack",
    startTime:"nov 1",
    tutor:"emily",
    duration:"6 months",
    timings:"10:00am to 07:00pm"  
  },
];

export const COURSE_CONFIG_THREE = [
    {
      id: 1,
      badge:"popular",
      image:"",
      course:"java full stack",
      startTime:"nov 1",
      tutor:"emily",
      duration:"3 months",
      timings:"10:00am to 07:00pm"  
    },
  ];



  // course main-cards config
//  cloud computing
export const CLOUD_CARD=[
  {
    heading:"Program In Relationship Management",
    text1:"34 weeks",
    text2:"Live Online",
    icon1:IMAGES.CALENDER_ICON,
    icon2:IMAGES.LIVE_ICON,
    bottomTxt:"Placements Opportunities",
    bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
  }
]

export const BANKING_CARD_1 ={
  heading:"Program In Relationship Management",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const BANKING_CARD_2 ={
  heading:"Relationship Management for Under Graduates ",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const BANKING_CARD_3 ={
  heading:"Program in Banking Sales & Relationship Management",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const BANKING_CARD_4 ={
  heading:"Banking Slaes and Relationship Mangement for Under Graduates",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}


// software engneering
export const SOFTWARE_CARD_1 ={
  heading:"Program In Relationship Management",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const SOFTWARE_CARD_2 ={
  heading:"Master JavaScript",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const SOFTWARE_CARD_3 ={
  heading:"Program in Banking Sales & Relationship Management",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const SOFTWARE_CARD_4 ={
  heading:"Mobile Development",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const SOFTWARE_CARD_5 ={
  heading:"Software Testing",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const SOFTWARE_CARD_6 ={
  heading:"Java Development",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const SOFTWARE_CARD_7 ={
  heading:"Automation Testing",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const SOFTWARE_CARD_8 ={
  heading:"Power Bi",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
export const SOFTWARE_CARD_9 ={
  heading:"Game Development",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON
}
// Data Science

export const DATA_Card_1={
  heading:"Program In Relationship Management",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const DATA_Card_2={
  heading:"Artificial Intelligence and Machine Learning ",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const DATA_Card_3={
  heading:"Program in Banking Sales & Relationship Management",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const DATA_Card_4={
  heading:"Mobile Development",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}

// Digital Marketing

export const DIGITAL_CARD_1={
  heading:"Program In Relationship Management",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const DIGITAL_CARD_2={
  heading:"SEO and Growth Markething",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const DIGITAL_CARD_3={
  heading:"Program in Banking Sales & Relationship Management",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const DIGITAL_CARD_4={
  heading:"Mobile Development",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const DIGITAL_CARD_5={
  heading:"Content Marketing",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}

// cyber security

export const CYBER_CARD_1={
  heading:"Cyber Security for Beginneers",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const CYBER_CARD_2={
  heading:"Advanced Cyber security",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
 
// Certification

export const CERTIFICATION_CARD_1={
  heading:"Python Certification ",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const CERTIFICATION_CARD_2={
  heading:"Java Certification Program",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const CERTIFICATION_CARD_3={
  heading:"AWS Certification Program",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const CERTIFICATION_CARD_4={
  heading:"Microsoft Azure Certification Program",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}
export const CERTIFICATION_CARD_5={
  heading:"Salesforce Certification Program",
  text1:"34 weeks",
  text2:"Live Online",
  icon1:IMAGES.CALENDER_ICON,
  icon2:IMAGES.LIVE_ICON,
  bottomTxt:"Placements Opportunities",
  bottomIcon:IMAGES.VERIFIED_ROUNDED_ICON

}


// course accordian
// Accordian

export const BANKING_ACCORDIAN_1={
  list:[
    {
      id:1,
      title:"Introduction to Relationship Management",
      content:"Understand the fundamentals of building and maintaining strong professional relationships."
    },
    {
      id:2,
      title:"Effective Communication & Active Listening",
      content:"Develop communication strategies that enhance client interactions and engagement."
    },
    {
      id:3,
      title:"Customer Relationship Management (CRM) Tools",
      content:"Learn how to use industry-standard CRM software like Salesforce and HubSpot."
    },
    {
      id:4,
      title:" Negotiation & Conflict Resolution",
      content:"Master the art of negotiation and resolving conflicts to maintain positive relationships."
    },
    {
      id:5,
      title:"Client Retention & Loyalty Strategies",
      content:"Discover strategies to improve client satisfaction and long-term retention."
    },
    {
      id:6,
      title:"Business Ethics & Trust Building",
      content:"Learn ethical principles that foster transparency and trust in relationships."
    },
    {
      id:7,
      title:"Sales & Customer Success Management",
      content:"Understand how to drive business growth by managing client relationships effectively."
    },
  ],
  image:IMAGES.BANKING_ACCORDIAN_1,
  
}
export const BANKING_ACCORDIAN_2={
  list:[
    {
      id:1,
      title:"Introduction to Relationship Management",
      content:"Understand the importance of building strong personal and professional relationships."
    },
    {
      id:2,
      title:"Effective Communication & Active Listening",
      content:"Develop skills to engage in meaningful conversations and express ideas clearly."
    },
    {
      id:3,
      title:"Networking & Personal Branding",
      content:"Learn how to create a strong LinkedIn profile, connect with professionals, and make a lasting impression."
    },
    {
      id:4,
      title:"Customer Relationship Management (CRM) Basics",
      content:"Get introduced to CRM tools used in businesses for managing client relationships."
    },
    {
      id:5,
      title:"Conflict Resolution & Negotiation Skills",
      content:"Master techniques to handle disagreements professionally and negotiate effectively."
    },
    {
      id:6,
      title:"Leadership & Teamwork",
      content:"Develop leadership qualities and understand the dynamics of working in a team."
    },
    {
      id:7,
      title:" Business Etiquette & Professionalism",
      content:"Learn the do’s and don’ts of professional communication, email etiquette, and workplace behavior."
    },
  ],
  image:IMAGES.BANKING_ACCORDIAN_2,
  
}

export const BANKING_ACCORDIAN_3={
  list:[
    {
      id:1,
      title:"Introduction to Banking Sales & Relationship Management",
      content:"Understand the role of sales and client management in the banking sector."
    },
    {
      id:2,
      title:" Banking Products & Financial Services",
      content:"Gain knowledge of retail banking, loans, credit cards, wealth management, and investment products."
    },
    {
      id:3,
      title:"CRM in Banking",
      content:"Learn how to use CRM tools to manage customer interactions and drive sales."
    },
    {
      id:4,
      title:"Sales Techniques & Persuasion Strategies",
      content:"Master the art of selling financial products through trust-building and consultative selling."
    },
    {
      id:5,
      title:"Retail & Corporate Banking Relationship Management",
      content:"Explore how to handle individual and business banking clients effectively."
    },
    {
      id:6,
      title:"Negotiation & Conflict Resolution in Banking",
      content:"Develop skills to handle customer objections and resolve disputes professionally."
    },
    {
      id:7,
      title:"Banking Regulations & Compliance",
      content:"Learn the do’s and don’ts of professional communication, email etiquette, and workplace behavior."
    },
  ],
  image:IMAGES.BANKING_ACCORDIAN_3,
  
}

export const BANKING_ACCORDIAN_4={
  list:[
    {
      id:1,
      title:"Introduction to Banking & Financial Services",
      content:"Understand how banks operate and the key financial products offered to customers."
    },
    {
      id:2,
      title:"Fundamentals of Sales & Persuasion in Banking",
      content:"Learn how to sell banking products effectively through customer-centric strategies."
    },
    {
      id:3,
      title:"Customer Relationship Management (CRM) in Banking",
      content:"Discover how banks manage customer data and build long-term relationships."
    },
    {
      id:4,
      title:"Retail Banking & Wealth Management",
      content:"Get insights into savings accounts, loans, credit cards, and investment services."
    },
    {
      id:5,
      title:" Handling Customer Queries & Conflict Resolution",
      content:"Develop professional communication skills to manage client concerns and objections."
    },
    {
      id:6,
      title:"Digital Banking & FinTech Trends",
      content:"Explore how technology is transforming banking with mobile apps, digital wallets, and AI-driven banking."
    },
    {
      id:7,
      title:"Regulatory Compliance & Ethics in Banking",
      content:"Learn the importance of KYC (Know Your Customer) norms, anti-money laundering (AML), and banking ethics."
    },
    {
      id:8,
      title:"Real-World Projects & Case Studies",
      content:"Work on practical case studies, sales pitch simulations, and role-playing exercises to apply banking strategies."
    },
  ],
  image:IMAGES.BANKING_ACCORDIAN_4,
  
}

// software
export const SOFTWARE_ACCORDIAN_1={
  list:[
    {
      id:1,
      title:"Frontend Development",
      content:`Master HTML, CSS, and JavaScript for building responsive and interactive user interfaces.
Learn modern frontend frameworks like React.js or Angular for dynamic web applications.`
    },
    {
      id:2,
      title:"Backend Development",
      content:`Understand server-side programming with Node.js and Express.js.
Build RESTful APIs to connect frontend and backend systems.`
    },
    {
      id:3,
      title:"Database Management",
      content:`Work with both SQL (e.g., MySQL, PostgreSQL) and NoSQL (e.g., MongoDB) databases.
Learn to design and manage databases for scalable applications.`
    },
    {
      id:4,
      title:"Version Control",
      content:`Use Git and GitHub for collaborative coding and version control.`
    },
    {
      id:5,
      title:"Authentication & Security",
      content:`Implement user authentication and authorization using JWT or OAuth.
Learn best practices for securing web applications.`
    },
    {
      id:6,
      title:"Deployment & DevOps",
      content:`Deploy applications using platforms like Heroku, AWS, or Netlify.
Understand CI/CD pipelines for efficient development workflows.`
    },
    {
      id:7,
      title:"Real-World Projects",
      content:"Build portfolio-worthy projects like a blog platform, e-commerce site, and a task management app."
    }
  ],
  image:IMAGES.SOFTWARE_ACCORDIAN_1,
  
}


export const SOFTWARE_ACCORDIAN_2={
  list:[
    {
      id:1,
      title:"Introduction to JavaScript",
      content:`Learn the basics of syntax, variables, operators, and data types.`
    },
    {
      id:2,
      title:"Control Flow & Functions",
      content:`Master conditional statements, loops, and reusable functions for dynamic code.`
    },
    {
      id:3,
      title:"Objects & Arrays",
      content:`Dive deep into JavaScript’s powerful data structures, including objects and arrays.`
    },
    {
      id:4,
      title:"DOM Manipulation",
      content:`Learn how to interact with and manipulate HTML and CSS dynamically using JavaScript.`
    },
    {
      id:5,
      title:"Asynchronous JavaScript",
      content:`Understand callbacks, promises, and async/await for handling asynchronous operations.`
    },
    {
      id:6,
      title:"Error Handling",
      content:` Improve your code's reliability with proper error handling techniques.`
    },
    {
      id:7,
      title:"ES6 & Beyond",
      content:" Get hands-on experience with the latest features of JavaScript like arrow functions, classes, and modules."
    },
    {
      id:8,
      title:"Real-World Projects",
      content:" Build practical, portfolio-worthy projects including a dynamic to-do list, interactive web apps, and more."
    }
  ],
  image:IMAGES.SOFTWARE_ACCORDIAN_2,
  
}

export const SOFTWARE_ACCORDIAN_3={
  list:[
    {
      id:1,
      title:"Introduction to React.js",
      content:`Learn the core principles of React.js, its benefits, and setup.`
    },
    {
      id:2,
      title:"JSX & Components",
      content:`Understand JSX syntax and how to build reusable UI components.`
    },
    {
      id:3,
      title:"State & Props Management",
      content:`Master how data flows in React applications using state and props.`
    },
    {
      id:4,
      title:"React Hooks",
      content:`Explore powerful hooks like useState, useEffect, and custom hooks.`
    },
    {
      id:5,
      title:"React Router",
      content:`Implement navigation and routing for seamless single-page applications.`
    },
    {
      id:6,
      title:"API Integration & Fetching Data",
      content:`Connect your React app to external APIs and handle asynchronous data.`
    },
    {
      id:7,
      title:"Performance Optimization",
      content:"Optimize performance using lazy loading, memoization, and best practices."
    },
    {
      id:8,
      title:"Building & Deploying React Apps",
      content:"Develop, test, and deploy fully functional React applications."
    },
    {
      id:9,
      title:"Real-World Projects",
      content:"Build practical projects like a weather app, task manager, and an interactive e-commerce UI."
    }
  ],
  image:IMAGES.SOFTWARE_ACCORDIAN_3,
  
}
export const SOFTWARE_ACCORDIAN_4={
  list:[
    {
      id:1,
      title:" Introduction to Mobile Development",
      content:`Understand the fundamentals of mobile app development for Android and iOS.`
    },
    {
      id:2,
      title:"Programming Languages & Frameworks",
      content:`Learn key technologies like Flutter, React Native, Swift, and Kotlin.`
    },
    {
      id:3,
      title:"UI/UX Design for Mobile Apps",
      content:`Create user-friendly and visually appealing interfaces for mobile applications.`
    },
    {
      id:4,
      title:"State Management & Navigation",
      content:`Master state management and implement seamless app navigation.`
    },
    {
      id:5,
      title:"API Integration & Data Handling",
      content:`Connect apps with external APIs and manage real-time data efficiently.`
    },
    {
      id:6,
      title:"Authentication & Security",
      content:`Implement secure authentication methods like OAuth and Firebase Authentication.`
    },
    {
      id:7,
      title:"Performance Optimization",
      content:"Optimize app performance for smooth and efficient user experiences."
    },
    {
      id:8,
      title:" Publishing Apps to Play Store & App Store",
      content:"Learn how to package, test, and deploy apps to Google Play and the Apple App Store."
    },
    {
      id:9,
      title:"Real-World Projects",
      content:"Build practical projects like a weather app, task manager, and an interactive e-commerce UI."
    }
  ],
  image:IMAGES.SOFTWARE_ACCORDIAN_4,
  
}
export const SOFTWARE_ACCORDIAN_5={
  list:[
    {
      id:1,
      title:"Introduction to Software Testing",
      content:`Understand the fundamentals of software testing, its importance, and key methodologies.`
    },
    {
      id:2,
      title:"Manual Testing Techniques",
      content:`Learn how to create and execute test cases, detect bugs, and report defects effectively.`
    },
    {
      id:3,
      title:"Automation Testing with Selenium & JUnit",
      content:`Master automation testing using industry-leading tools like Selenium WebDriver and JUnit.`
    },
    {
      id:4,
      title:"API Testing with Postman",
      content:`Test APIs efficiently using Postman, covering RESTful services and automated API validations.`
    },
    {
      id:5,
      title:"Performance Testing with JMeter",
      content:`Ensure application scalability and responsiveness by conducting performance tests with JMeter.`
    },
    {
      id:6,
      title:"Test Management & Bug Tracking",
      content:`Utilize tools like JIRA and TestRail to manage test cases, track bugs, and report issues.`
    },
    {
      id:7,
      title:"Security Testing",
      content:"Learn how to identify vulnerabilities and ensure application security best practices."
    },
    {
      id:8,
      title:" CI/CD & DevOps Testing",
      content:"Understand the role of testing in Continuous Integration/Continuous Deployment (CI/CD) pipelines."
    },
    {
      id:9,
      title:"Real-World Projects",
      content:"Work on live testing scenarios, including web and mobile application testing, automation frameworks, and API testing strategies."
    },
  ],
  image:IMAGES.SOFTWARE_ACCORDIAN_5,
  
}
export const SOFTWARE_ACCORDIAN_6={
  list:[
    {
      id:1,
      title:" Introduction to Java Programming",
      content:`Learn Java syntax, data types, and basic programming concepts.`
    },
    {
      id:2,
      title:"Object-Oriented Programming (OOP) in Java",
      content:`Master OOP principles like inheritance, polymorphism, encapsulation, and abstraction.`
    },
    {
      id:3,
      title:"Data Structures & Algorithms in Java",
      content:`Learn how to implement and optimize essential data structures and algorithms.`
    },
    {
      id:4,
      title:"Java Collections Framework",
      content:`Understand lists, sets, maps, and queues to manage data efficiently.`
    },
    {
      id:5,
      title:"Multithreading & Concurrency",
      content:`Learn how to write efficient, concurrent Java programs using threads.`
    },
    {
      id:6,
      title:"Database Connectivity with JDBC",
      content:`Integrate Java applications with databases using SQL and JDBC.`
    },
    {
      id:7,
      title:"Spring Framework & Hibernate",
      content:"Develop enterprise-grade applications with Spring Boot and Hibernate ORM."
    },
    {
      id:8,
      title:"RESTful API Development",
      content:"Build scalable APIs and integrate them with Java applications."
    },
    {
      id:9,
      title:"Real-World Projects",
      content:"Develop portfolio-worthy applications like a banking system, e-commerce platform, and employee management system."
    },
  ],
  image:IMAGES.SOFTWARE_ACCORDIAN_6,
  
}


export const SOFTWARE_ACCORDIAN_7={
  list:[
    {
      id:1,
      title:"Introduction to Automation Testing",
      content:`Understand the fundamentals of automation testing and its benefits over manual testing.`
    },
    {
      id:2,
      title:"Selenium WebDriver & TestNG",
      content:`Learn to automate web application testing using Selenium WebDriver and TestNG framework.`
    },
    {
      id:3,
      title:"API Testing with Postman & RestAssured",
      content:`Master API automation using Postman and RestAssured for efficient backend testing.`
    },
    {
      id:4,
      title:"Performance Testing with JMeter",
      content:`Ensure application scalability by conducting performance and load testing with JMeter.`
    },
    {
      id:5,
      title:"Cucumber & Behavior-Driven Development (BDD)",
      content:`Implement BDD using Cucumber to write human-readable test cases.`
    },
    {
      id:6,
      title:"CI/CD & DevOps Testing",
      content:`Integrate automation tests into CI/CD pipelines using Jenkins and Docker.`
    },
    {
      id:7,
      title:"Mobile Automation Testing with Appium",
      content:"Automate mobile application testing for Android and iOS using Appium."
    },
    {
      id:8,
      title:"Test Management with JIRA & TestRail",
      content:"Track test cases, manage defects, and report bugs efficiently using JIRA and TestRail."
    },
    {
      id:9,
      title:"Real-World Projects",
      content:"Develop portfolio-worthy automation frameworks for web, API, and mobile testing."
    },
  ],
  image:IMAGES.SOFTWARE_ACCORDIAN_7,
  
}
export const SOFTWARE_ACCORDIAN_8={
  list:[
    {
      id:1,
      title:"Introduction to Power BI",
      content:`Understand the fundamentals of Power BI, including data visualization concepts.`
    },
    {
      id:2,
      title:" Data Import & Transformation with Power Query",
      content:`Learn how to connect to various data sources and clean, shape, and transform data.`
    },
    {
      id:3,
      title:" Data Modeling & DAX (Data Analysis Expressions)",
      content:`Master DAX formulas to create calculated columns, measures, and custom functions.`
    },
    {
      id:4,
      title:"Interactive Dashboards & Reports",
      content:`Create compelling and dynamic dashboards with slicers, filters, and drill-through options.`
    },
    {
      id:5,
      title:"Data Relationships & Business Intelligence",
      content:`Understand data relationships and apply business intelligence principles.`
    },
    {
      id:6,
      title:"Power BI Service & Cloud Sharing",
      content:`Learn how to publish and share reports securely in the Power BI Service.`
    },
    {
      id:7,
      title:"Advanced Visualization Techniques",
      content:"Enhance reports with custom visuals, conditional formatting, and storytelling."
    },
    {
      id:8,
      title:"Power Automate & AI Features",
      content:"Leverage automation and AI-powered analytics to gain deeper insights."
    },
    {
      id:9,
      title:"Real-World Projects",
      content:"Develop portfolio-worthy dashboards, including financial reports, sales analytics, and customer insights."
    },
  ],
  image:IMAGES.SOFTWARE_ACCORDIAN_8,
  
}
export const SOFTWARE_ACCORDIAN_9={
  list:[
    {
      id:1,
      title:"Introduction to Game Development",
      content:`Understand the fundamentals of game design, mechanics, and storytelling.`
    },
    {
      id:2,
      title:"Programming with C# & Unity",
      content:`Learn game scripting using C# in Unity for creating dynamic gameplay.`
    },
    {
      id:3,
      title:"Unreal Engine & Blueprints",
      content:`Master game development with Unreal Engine and its powerful visual scripting tool, Blueprints.`
    },
    {
      id:4,
      title:"2D & 3D Game Development",
      content:`Create stunning 2D and 3D games with animations, physics, and interactive elements.`
    },
    {
      id:5,
      title:"Game Physics & AI",
      content:`Implement physics-based interactions and AI-driven NPC behavior.`
    },
    {
      id:6,
      title:"Multiplayer & Networking",
      content:`Build online multiplayer games using Photon and Unity’s networking solutions.`
    },
    {
      id:7,
      title:"Sound & Visual Effects",
      content:"Enhance games with high-quality sound effects, background music, and VFX."
    },
    {
      id:8,
      title:"Game Monetization & Publishing",
      content:"Learn how to publish games on platforms like Steam, Play Store, and App Store."
    },
    {
      id:9,
      title:"Real-World Projects",
      content:"Develop portfolio-worthy games, including platformers, RPGs, and first-person shooters."
    },
  ],
  image:IMAGES.SOFTWARE_ACCORDIAN_9,
  
}

// data science

export const DATA_ACCORDIAN_1={
  list:[
    {
      id:1,
      title:"Introduction to Data Science & ML",
      content:`Understand the fundamentals of data science, machine learning, and AI applications.`
    },
    {
      id:2,
      title:"Python for Data Science",
      content:`Learn Python programming, NumPy, Pandas, Matplotlib, and data manipulation techniques.`
    },
    {
      id:3,
      title:"Data Visualization & Storytelling",
      content:`Master tools like Tableau, Power BI, and Seaborn to present insights effectively.`
    },
    {
      id:4,
      title:"SQL & Big Data Handling",
      content:`Gain expertise in SQL queries, database management, and handling large datasets.`
    },
    {
      id:5,
      title:"Machine Learning Algorithms",
      content:`Explore supervised and unsupervised learning, including regression, classification, and clustering.`
    },
    {
      id:6,
      title:" Deep Learning & Neural Networks",
      content:`Work with TensorFlow and PyTorch to build AI-driven solutions.`
    },
    {
      id:7,
      title:"Model Evaluation & Optimization",
      content:"Learn about accuracy metrics, overfitting prevention, and hyperparameter tuning."
    },
    {
      id:8,
      title:"Real-World Projects & AI Applications",
      content:"Develop predictive models, recommendation systems, and automation solutions."
    }
  ],
  image:IMAGES.DATA_ACCORDIAN_1,
  
}
export const DATA_ACCORDIAN_2={
  list:[
    {
      id:1,
      title:"Introduction to AI & ML",
      content:`Understand the fundamentals of AI, machine learning, and deep learning concepts.`
    },
    {
      id:2,
      title:"Python for AI Development",
      content:`Master Python libraries like TensorFlow, Keras, NumPy, and Pandas for AI applications.`
    },
    {
      id:3,
      title:"Supervised & Unsupervised Learning",
      content:`Learn regression, classification, clustering, and feature engineering techniques.`
    },
    {
      id:4,
      title:"Deep Learning & Neural Networks",
      content:`Explore artificial neural networks (ANNs), convolutional neural networks (CNNs), and recurrent neural networks (RNNs).`
    },
    {
      id:5,
      title:"Natural Language Processing (NLP)",
      content:`Build AI models for speech recognition, chatbots, and text analysis.`
    },
    {
      id:6,
      title:"Computer Vision & Image Recognition",
      content:`Develop AI-powered solutions using OpenCV and TensorFlow for image processing.`
    },
    {
      id:7,
      title:"AI Ethics & Responsible AI Development",
      content:"Learn about bias detection, fairness, and the ethical impact of AI."
    },
    {
      id:8,
      title:"Real-World Projects & AI Applications",
      content:"Work on AI solutions for automation, recommendation systems, and self-learning models."
    }
  ],
  image:IMAGES.DATA_ACCORDIAN_2,
  
}
export const DATA_ACCORDIAN_3={
  list:[
    {
      id:1,
      title:" Introduction to Data Analytics",
      content:`Understand data analytics fundamentals, key concepts, and business applications.`
    },
    {
      id:2,
      title:"SQL for Data Extraction & Management",
      content:`Learn how to write SQL queries, manage databases, and perform data manipulation.`
    },
    {
      id:3,
      title:" Python for Data Analysis",
      content:`Use Python libraries like Pandas, NumPy, and Matplotlib for efficient data handling and visualization.`
    },
    {
      id:4,
      title:"Data Cleaning & Preprocessing",
      content:`Master techniques to clean and preprocess raw data for accurate analysis.`
    },
    {
      id:5,
      title:"Data Visualization & Reporting",
      content:`Create interactive dashboards using Python, SQL, and Power BI.`
    },
    {
      id:6,
      title:"Statistical Analysis & Hypothesis Testing",
      content:`Apply statistical methods to analyze trends, patterns, and relationships in data.`
    },
    {
      id:7,
      title:"Exploratory Data Analysis (EDA)",
      content:"Learn how to interpret datasets, detect anomalies, and generate insights."
    },
    {
      id:8,
      title:"Real-World Projects & AI Applications",
      content:"Work on AI solutions for automation, recommendation systems, and self-learning models."
    }
  ],
  image:IMAGES.DATA_ACCORDIAN_3,
  
}
export const DATA_ACCORDIAN_4={
  list:[
    {
      id:1,
      title:"Introduction to AI Engineering",
      content:`Understand the fundamentals of artificial intelligence, its applications, and ethical considerations.`
    },
    {
      id:2,
      title:"Python for AI & Machine Learning",
      content:`Master Python libraries like TensorFlow, Keras, NumPy, and Pandas for AI development.`
    },
    {
      id:3,
      title:"Supervised & Unsupervised Learning",
      content:`Learn machine learning techniques, including regression, classification, and clustering.`
    },
    {
      id:4,
      title:"Data Cleaning & Preprocessing",
      content:`Master techniques to clean and preprocess raw data for accurate analysis.`
    },
    {
      id:5,
      title:"Deep Learning & Neural Networks",
      content:`Work with artificial neural networks (ANNs), convolutional neural networks (CNNs), and recurrent neural networks (RNNs).`
    },
    {
      id:6,
      title:"Natural Language Processing (NLP)",
      content:`Build AI models for chatbots, speech recognition, and text analytics.`
    },
    {
      id:7,
      title:"Computer Vision & Image Recognition",
      content:"Develop AI-powered solutions using OpenCV, TensorFlow, and deep learning models."
    },
    {
      id:8,
      title:"AI Model Deployment & Optimization",
      content:"Learn to deploy AI models on cloud platforms and optimize for real-world applications."
    },
    {
      id:9,
      title:"Real-World Projects & AI Applications",
      content:"Work on AI solutions for automation, recommendation systems, and robotics."
    }
  ],
  image:IMAGES.DATA_ACCORDIAN_4,
  
}

// digital

export const DIGITAL_ACCORDIAN_1={
  list:[
    {
      id:1,
      title:"Introduction to Digital Marketing & AI",
      content:`Understand the fundamentals of digital marketing and how AI is revolutionizing the industry.`
    },
    {
      id:2,
      title:"Generative AI for Content Creation",
      content:`Use AI tools like ChatGPT, Jasper, and Midjourney to create high-quality marketing content.`
    },
    {
      id:3,
      title:"SEO & AI-Optimized Content Strategy",
      content:`Leverage AI-powered SEO techniques to improve rankings and organic reach.`
    },
    {
      id:4,
      title:"AI in Social Media & Paid Ads",
      content:`Automate ad campaigns, audience targeting, and performance analysis with AI.`
    },
    {
      id:5,
      title:"Personalized Email & Chatbot Marketing",
      content:`Use AI for automated email marketing and customer engagement chatbots.`
    },
    {
      id:6,
      title:"AI-Driven Analytics & Marketing Insights",
      content:`Utilize AI tools for audience behavior analysis, predictive analytics, and performance tracking.`
    },
    {
      id:7,
      title:"Marketing Automation & AI Tools",
      content:"Master automation tools like HubSpot, Google AI, and AI-powered CRM systems."
    },
    {
      id:8,
      title:"Real-World Projects & AI Applications",
      content:"Work on AI-driven campaigns for social media, e-commerce, and brand awareness."
    }
  ],
  image:IMAGES.DIGITAL_ACCORDIAN_1,
  
}
export const DIGITAL_ACCORDIAN_2={
  list:[
    {
      id:1,
      title:"Introduction to SEO & Growth Marketing",
      content:`Understand search engine algorithms, user behavior, and growth marketing principles.`
    },
    {
      id:2,
      title:"Keyword Research & On-Page SEO",
      content:`Learn how to find high-ranking keywords and optimize content for search engines.`
    },
    {
      id:3,
      title:"Technical SEO & Site Performance",
      content:`Master website speed optimization, mobile-friendliness, and technical SEO audits.`
    },
    {
      id:4,
      title:"AI in Social Media & Paid Ads",
      content:`Automate ad campaigns, audience targeting, and performance analysis with AI.`
    },
    {
      id:5,
      title:"Off-Page SEO & Link Building",
      content:`Develop authority through high-quality backlinks, guest blogging, and influencer outreach.`
    },
    {
      id:6,
      title:"AI-Powered SEO & Content Optimization",
      content:`Use AI tools like ChatGPT, SurferSEO, and Clearscope to automate content strategies.`
    },
    {
      id:7,
      title:"Conversion Rate Optimization (CRO)",
      content:"Optimize landing pages, user experience, and A/B testing for better conversion rates."
    },
    {
      id:8,
      title:"Paid Ads & Growth Hacking Techniques",
      content:"Understand Google Ads, Facebook Ads, and viral marketing strategies for rapid growth."
    },
    {
      id:9,
      title:"Real-World Projects & AI Applications",
      content:"Work on website audits, case studies, and data-driven growth experiments."
    },
  ],
  image:IMAGES.DIGITAL_ACCORDIAN_2,
  
}
export const DIGITAL_ACCORDIAN_3={
  list:[
    {
      id:1,
      title:"Introduction to Social Media & Influencer Marketing",
      content:`Understand how social media platforms work and the power of influencer collaborations.`
    },
    {
      id:2,
      title:"Content Creation & AI-Driven Marketing",
      content:`Learn how to create engaging content using AI tools like ChatGPT, Canva, and Midjourney.`
    },
    {
      id:3,
      title:"Social Media Branding & Growth Strategies",
      content:`Develop effective strategies to grow brand presence and increase engagement.`
    },
    {
      id:4,
      title:"Influencer Outreach & Partnership Strategies",
      content:`Master influencer selection, negotiation, and campaign execution techniques.`
    },
    {
      id:5,
      title:"Social Media Ads & Paid Campaigns",
      content:`Optimize ad strategies on Facebook, Instagram, LinkedIn, and TikTok.`
    },
    {
      id:6,
      title:"Viral Marketing & Engagement Hacks",
      content:`Understand how to create viral content and maximize reach with trending strategies.`
    },
    {
      id:7,
      title:"Analytics & ROI Measurement",
      content:"Use AI and marketing tools to track performance, engagement, and campaign success."
    },
    {
      id:8,
      title:"Real-World Projects & AI Applications",
      content:"Plan and execute influencer collaborations, ad campaigns, and brand awareness projects."
    },
  ],
  image:IMAGES.DIGITAL_ACCORDIAN_3,
  
}
export const DIGITAL_ACCORDIAN_4={
  list:[
    {
      id:1,
      title:"Introduction to Email Marketing",
      content:`Understand how email marketing works and its role in digital strategy.`
    },
    {
      id:2,
      title:" Email Copywriting & Design Best Practices",
      content:`Learn how to craft persuasive subject lines, email copy, and visually appealing templates.`
    },
    {
      id:3,
      title:"Audience Segmentation & Personalization",
      content:`Master segmentation techniques to send targeted and personalized emails.`
    },
    {
      id:4,
      title:"Influencer Outreach & Partnership Strategies",
      content:`Master influencer selection, negotiation, and campaign execution techniques.`
    },
    {
      id:5,
      title:"Email Automation & AI-Powered Campaigns",
      content:`Use AI-driven tools like Mailchimp, HubSpot, and Klaviyo for automation.`
    },
    {
      id:6,
      title:"A/B Testing & Conversion Optimization",
      content:`Optimize subject lines, CTA buttons, and email layouts for higher engagement.`
    },
    {
      id:7,
      title:"Deliverability & Compliance",
      content:"Understand spam filters, email regulations (GDPR, CAN-SPAM), and best practices."
    },
    {
      id:8,
      title:" Analytics & Performance Tracking",
      content:"Measure open rates, click-through rates, and conversions with AI-driven insights."
    },
    {
      id:9,
      title:"Real-World Projects & AI Applications",
      content:"Plan and execute promotional, transactional, and engagement email sequences."
    },
  ],
  image:IMAGES.DIGITAL_ACCORDIAN_4,
  
}
export const DIGITAL_ACCORDIAN_5={
  list:[
    {
      id:1,
      title:"Introduction to Content Marketing",
      content:`Understand content marketing fundamentals and how it drives business growth.`
    },
    {
      id:2,
      title:"Brand Storytelling & Audience Engagement",
      content:`Learn how to create compelling narratives that resonate with audiences.`
    },
    {
      id:3,
      title:"SEO & Content Optimization",
      content:`Master keyword research, on-page SEO, and content structuring for search engines.`
    },
    {
      id:4,
      title:"AI-Powered Content Creation",
      content:`Use AI tools like ChatGPT, Jasper, and SurferSEO for faster and optimized content production.`
    },
    {
      id:5,
      title:"Blogging & Website Content Strategy",
      content:`Develop high-quality blog posts and website copy that drive traffic and conversions.`
    },
    {
      id:6,
      title:"Social Media & Video Content Marketing",
      content:`Create engaging social media posts, video scripts, and reels that increase reach.`
    },
    {
      id:7,
      title:"Email & Newsletter Marketing",
      content:"Write effective newsletters that nurture leads and drive customer engagement."
    },
    {
      id:8,
      title:" Analytics & Performance Tracking",
      content:"Measure open rates, click-through rates, and conversions with AI-driven insights."
    },
    {
      id:9,
      title:"Real-World Content Marketing Projects",
      content:"Plan and execute content strategies for brands, build content calendars, and analyze performance metrics."
    },
  ],
  image:IMAGES.DIGITAL_ACCORDIAN_5,
  
}

// cyber

export const CYBER_ACCORDIAN_1={
  list:[
    {
      id:1,
      title:"Introduction to Cyber Security",
      content:`Understand the importance of cybersecurity, common threats, and defense mechanisms.`
    },
    {
      id:2,
      title:"Ethical Hacking & Penetration Testing Basics",
      content:`Learn how hackers exploit vulnerabilities and how to prevent cyberattacks.`
    },
    {
      id:3,
      title:"Network Security & Firewalls",
      content:`Secure networks using firewalls, intrusion detection systems, and access controls.`
    },
    {
      id:4,
      title:"Encryption & Data Protection",
      content:`Understand cryptography techniques and how to secure sensitive data.`
    },
    {
      id:5,
      title:"Malware Analysis & Prevention",
      content:`Learn how viruses, ransomware, and spyware work and how to protect systems.`
    },
    {
      id:6,
      title:"Cyber Laws & Ethical Practices",
      content:`Get familiar with global cybersecurity laws, ethical hacking principles, and data privacy regulations.`
    },
    {
      id:7,
      title:"Incident Response & Cyber Threat Management",
      content:"Develop skills to detect, analyze, and respond to cyber threats effectively."
    },
    {
      id:8,
      title:"Real-World Projects & AI Applications",
      content:"Work on AI-driven campaigns for social media, e-commerce, and brand awareness."
    },
    {
      id:9,
      title:"Real-World Cyber Security Projects",
      content:"Simulate real-world attacks, implement security measures, and conduct vulnerability assessments."
    },
  ],
  image:IMAGES.CYBER_ACCORDIAN_1,
  
}
export const CYBER_ACCORDIAN_2={
  list:[
    {
      id:1,
      title:"Cyber Threat Intelligence & Analysis",
      content:`Master techniques for identifying and analyzing sophisticated cyber threats.`
    },
    {
      id:2,
      title:"Advanced Penetration Testing & Ethical Hacking",
      content:`Simulate real-world attacks to identify security vulnerabilities.`
    },
    {
      id:3,
      title:"Enterprise Network Security & Zero Trust Architecture",
      content:`Implement security frameworks like Zero Trust, VPNs, and advanced firewalls.`
    },
    {
      id:4,
      title:"Cloud Security & DevSecOps",
      content:`Secure cloud environments, SaaS applications, and implement DevSecOps best practices.`
    },
    {
      id:5,
      title:"AI & Machine Learning in Cyber Security",
      content:`Use AI-driven tools to detect anomalies, automate security monitoring, and predict cyber attacks.`
    },
    {
      id:6,
      title:"Incident Response & Cyber Forensics",
      content:`Develop response plans for cyber attacks and learn forensic investigation techniques.`
    },
    {
      id:7,
      title:"Advanced Cryptography & Blockchain Security",
      content:"Implement modern encryption standards, digital signatures, and blockchain security protocols."
    },
    {
      id:8,
      title:"Real-World Cyber Security Projects",
      content:"Perform red team vs. blue team exercises, simulate ransomware attacks, and analyze security breaches."
    },
  ],
  image:IMAGES.CYBER_ACCORDIAN_2,
  
}

// Ccloud
export const CLOUD_ACCORDIAN={
  list:[
    {
      id:1,
      title:"IT System Administration Fundamentals",
      content:`Learn how to install, configure, and manage Windows and Linux servers.`
    },
    {
      id:2,
      title:"Networking & Security Essentials",
      content:`Master TCP/IP, firewalls, VPNs, DNS, and security best practices for enterprise environments.`
    },
    {
      id:3,
      title:"Cloud Computing with AWS, Azure & Google Cloud",
      content:`Set up, configure, and manage virtual machines, storage, and cloud networking.`
    },
    {
      id:4,
      title:"Virtualization & Containerization",
      content:`Work with VMware, Docker, and Kubernetes to optimize IT infrastructure.`
    },
    {
      id:5,
      title:"IT Security & Compliance",
      content:`Learn system hardening, patch management, and compliance frameworks (ISO 27001, GDPR, NIST).`
    },
    {
      id:6,
      title:"Automation & Scripting",
      content:`Use PowerShell, Bash scripting, and Terraform to automate IT tasks and cloud deployments.`
    },
    {
      id:7,
      title:"Incident Response & Cyber Threat Management",
      content:"Develop skills to detect, analyze, and respond to cyber threats effectively."
    },
    {
      id:8,
      title:"Backup & Disaster Recovery",
      content:"Implement data backup strategies, failover systems, and cloud-based recovery solutions."
    },
    {
      id:9,
      title:"Real-World IT Projects",
      content:"Work on live cloud deployments, security audits, and IT support case studies to build practical experience."
    },
  ],
  image:IMAGES.CLOUD_ACCORDIAN,
  
}

// Certification

export const CERTIFICATION_ACCORDIAN_1={
  list:[
    {
      id:1,
      title:"Python Fundamentals & Syntax",
      content:`Learn variables, loops, functions, and object-oriented programming (OOP).`
    },
    {
      id:2,
      title:"Data Structures & Algorithms in Python",
      content:`Master lists, tuples, dictionaries, and algorithmic problem-solving.`
    },
    {
      id:3,
      title:"Automation with Python",
      content:`Use Python for task automation, scripting, and working with APIs.`
    },
    {
      id:4,
      title:"Web Development with Flask & Django",
      content:`Build dynamic websites and backend applications using Flask & Django frameworks.`
    },
    {
      id:5,
      title:"Data Analysis & Visualization",
      content:`Work with Pandas, NumPy, and Matplotlib to analyze and visualize data.`
    },
    {
      id:6,
      title:"Machine Learning with Python",
      content:`Get introduced to scikit-learn, TensorFlow, and AI-driven applications.`
    },
    {
      id:7,
      title:"Error Handling & Debugging",
      content:"Learn best practices for writing clean, efficient, and error-free Python code."
    },
    {
      id:8,
      title:"Real-World Python Projects",
      content:"Develop portfolio-worthy projects including automation scripts, web apps, and data-driven dashboards."
    }
  ],
  image:IMAGES.CERTIFICATION_ACCORDIAN_1,
  
}
export const CERTIFICATION_ACCORDIAN_2={
  list:[
    {
      id:1,
      title:"Java Fundamentals & Syntax",
      content:`Learn variables, loops, functions, and object-oriented programming (OOP).`
    },
    {
      id:2,
      title:"Data Structures & Algorithms with Java",
      content:`Master arrays, linked lists, stacks, queues, and algorithmic problem-solving.`
    },
    {
      id:3,
      title:"Multithreading & Concurrency",
      content:`Learn how to write efficient, high-performance applications using Java threading.`
    },
    {
      id:4,
      title:"Web Development with Java (Spring Boot & Servlets)",
      content:`Build dynamic web applications, REST APIs, and enterprise-level solutions.`
    },
    {
      id:5,
      title:"Database Connectivity (JDBC, Hibernate, MySQL)",
      content:`Integrate Java applications with databases for secure and efficient data storage.`
    },
    {
      id:6,
      title:"Microservices Architecture",
      content:`Develop and deploy scalable microservices using Java frameworks.`
    },
    {
      id:7,
      title:"Error Handling & Debugging",
      content:"Implement best practices for handling exceptions and debugging Java applications."
    },
    {
      id:8,
      title:"Real-World Java Projects",
      content:"Work on portfolio-worthy projects such as e-commerce applications, banking systems, and cloud-based services."
    }
  ],
  image:IMAGES.CERTIFICATION_ACCORDIAN_2,
  
}
export const CERTIFICATION_ACCORDIAN_3={
  list:[
    {
      id:1,
      title:"AWS Fundamentals & Cloud Computing",
      content:`Understand AWS architecture, regions, availability zones, and cloud principles.`
    },
    {
      id:2,
      title:"Compute & Storage Services (EC2, S3, EBS, RDS, Lambda)",
      content:`Deploy and manage scalable cloud infrastructure.`
    },
    {
      id:3,
      title:"Networking & Security (VPC, IAM, CloudTrail, Shield, WAF)",
      content:`Learn how to secure cloud environments and configure networking solutions.`
    },
    {
      id:4,
      title:"Serverless Computing & Automation",
      content:`Work with Lambda, API Gateway, CloudFormation, and Terraform.`
    },
    {
      id:5,
      title:" DevOps on AWS",
      content:`Implement continuous integration, deployment, and containerized applications.`
    },
    {
      id:6,
      title:"Cloud Migration & Cost Optimization",
      content:`Learn best practices for cloud migration and AWS cost management.`
    },
    {
      id:7,
      title:"Real-World AWS Projects",
      content:"Work on live cloud deployments, security audits, and DevOps automation scripts."
    }
  ],
  image:IMAGES.CERTIFICATION_ACCORDIAN_3,
  
}
export const CERTIFICATION_ACCORDIAN_4={
  list:[
    {
      id:1,
      title:"Azure Fundamentals & Cloud Concepts",
      content:`Understand Azure architecture, cloud computing models, and core services.`
    },
    {
      id:2,
      title:"Compute & Storage Services",
      content:`Deploy and manage cloud-based virtual machines, storage solutions, and databases.`
    },
    {
      id:3,
      title:"Networking & Security",
      content:`Learn secure networking, identity management, and compliance best practices.`
    },
    {
      id:4,
      title:"Serverless Computing & Automation",
      content:`Work with Azure Functions, Logic Apps, and ARM Templates for automation.`
    },
    {
      id:5,
      title:"DevOps on Azure",
      content:`Implement continuous integration, deployment, and Kubernetes-based solutions.`
    },
    {
      id:6,
      title:"Cloud Migration & Cost Optimization",
      content:`Learn Azure migration strategies, cost management, and performance optimization.`
    },
    {
      id:7,
      title:"Real-World AWS Projects",
      content:"Work on live cloud deployments, enterprise security, and automated DevOps workflows."
    }
  ],
  image:IMAGES.CERTIFICATION_ACCORDIAN_4,
  
}
export const CERTIFICATION_ACCORDIAN_5={
  list:[
    {
      id:1,
      title:"Salesforce Fundamentals & Cloud CRM",
      content:`Understand Salesforce ecosystem, cloud CRM architecture, and core functionalities.`
    },
    {
      id:2,
      title:"Salesforce Administration",
      content:`Learn to manage users, roles, permissions, data security, and business reports.`
    },
    {
      id:3,
      title:"Salesforce Automation",
      content:`Automate business processes, approvals, and customer interactions.`
    },
    {
      id:4,
      title:"Data Management & Integration",
      content:`Work with Salesforce Object Model, SOQL, and data migration tools.`
    },
    {
      id:5,
      title:"Salesforce Development",
      content:`Build custom applications and UI enhancements using Apex and LWC.`
    },
    {
      id:6,
      title:"Customer Engagement & Analytics",
      content:`Leverage Sales Cloud, Service Cloud, and Einstein Analytics for data-driven decisions.`
    },
    {
      id:7,
      title:"Real-World Salesforce Projects",
      content:"Work on live Salesforce implementations, automation workflows, and CRM solutions."
    }
  ],
  image:IMAGES.CERTIFICATION_ACCORDIAN_5,
  
}

// Design
export const DESIGN_ACCORDIAN_1={
  list:[
    {
      id:1,
      title:"Introduction to UI/UX Design",
      content:`Understand design principles, color theory, typography, and branding.`
    },
    {
      id:2,
      title:"User Research & Design Thinking",
      content:`Learn user personas, journey mapping, and behavioral analytics to create user-centered designs.`
    },
    {
      id:3,
      title:"Wireframing & Prototyping",
      content:`Create low-fidelity and high-fidelity wireframes using Figma, Adobe XD, and Balsamiq.`
    },
    {
      id:4,
      title:" Usability Testing & Feedback Implementation",
      content:`Conduct A/B testing, usability tests, and iterate based on real user feedback.`
    },
    {
      id:5,
      title:"Mobile & Web Interface Design",
      content:`Design responsive and accessible UIs optimized for different devices.`
    },
    {
      id:6,
      title:" Interaction Design & Microinteractions",
      content:`Enhance user engagement with animations, transitions, and intuitive navigation.`
    },
    {
      id:7,
      title:"Portfolio Development & Real-World Projects",
      content:"Work on e-commerce, SaaS, and mobile app design projects to build an impressive portfolio."
    }
  ],
  image:IMAGES.DESIGN_ACCORDIAN_1,
  
}
export const DESIGN_ACCORDIAN_2={
  list:[
    {
      id:1,
      title:"Fundamentals of Graphic Design",
      content:`Understand design principles, color theory, typography, and composition.`
    },
    {
      id:2,
      title:"Logo & Branding Design",
      content:`Create brand identities, business cards, and style guides using Adobe Illustrator.`
    },
    {
      id:3,
      title:"Digital Illustration & Vector Art",
      content:`Learn vector drawing techniques for creating icons, infographics, and illustrations.`
    },
    {
      id:4,
      title:"Photo Editing & Manipulation",
      content:`Master Adobe Photoshop for image retouching, blending, and digital artwork.`
    },
    {
      id:5,
      title:"Print & Publication Design",
      content:`Work on brochures, magazines, packaging, and marketing collateral.`
    },
    {
      id:6,
      title:"Motion Graphics & Social Media Design",
      content:`Design animated graphics, reels, and social media visuals with After Effects & Canva.`
    },
    {
      id:7,
      title:"Portfolio Development & Real-World Projects",
      content:"Work on branding projects, ad campaigns, and UI design to create an impressive portfolio."
    }
  ],
  image:IMAGES.DESIGN_ACCORDIAN_2,
  
}
export const DESIGN_ACCORDIAN_3={
  list:[
    {
      id:1,
      title:"Introduction to Product Design",
      content:`Learn core principles, human-centered design, and the product development lifecycle.`
    },
    {
      id:2,
      title:"User Research & Market Analysis",
      content:`Understand user needs, competitor analysis, and market trends.`
    },
    {
      id:3,
      title:"Wireframing & Digital Prototyping",
      content:`Create interactive UI/UX wireframes using Figma, Sketch, and Adobe XD.`
    },
    {
      id:4,
      title:"3D Modeling & Industrial Design",
      content:`Master SolidWorks, AutoCAD, and Fusion 360 for 3D product visualization.`
    },
    {
      id:5,
      title:"Materials & Manufacturing",
      content:`Explore sustainable materials, 3D printing, and manufacturing processes.`
    },
    {
      id:6,
      title:"Usability Testing & Design Iteration",
      content:`Conduct A/B testing, user feedback sessions, and product refinements.`
    },
    {
      id:7,
      title:"Portfolio Development & Real-World Projects",
      content:"Work on consumer electronics, mobile apps, and industrial design projects."
    }
  ],
  image:IMAGES.DESIGN_ACCORDIAN_3,
  
}

// Agile and scrum

export const AGILE_ACCORDIAN_1={
  list:[
    {
      id:1,
      title:"Introduction to Agile & Scrum",
      content:`Understand Agile principles, Scrum values, and the Agile Manifesto.`
    },
    {
      id:2,
      title:"Scrum Roles & Responsibilities",
      content:`Learn the roles of Scrum Master, Product Owner, and Development Team.`
    },
    {
      id:3,
      title:"Sprint Planning & Backlog Management",
      content:`Manage Product Backlogs, Sprint Backlogs, and prioritize tasks effectively.`
    },
    {
      id:4,
      title:"Facilitating Scrum Events",
      content:`Master Daily Stand-ups, Sprint Reviews, and Sprint Retrospectives.`
    },
    {
      id:5,
      title:"Scaling Scrum & Agile Frameworks",
      content:`Explore SAFe (Scaled Agile Framework), LeSS (Large-Scale Scrum), and Scrum@Scale.`
    },
    {
      id:6,
      title:"Agile Metrics & Continuous Improvement",
      content:`Track team performance using Burndown Charts, Velocity, and KPI measurement.`
    },
    {
      id:7,
      title:"Scrum Master Best Practices & Career Guidance",
      content:"Prepare for the CSM certification exam with mock tests, case studies, and resume-building tips."
    }
  ],
  image:IMAGES.AGILE_ACCORDIAN_1,
  
}
export const AGILE_ACCORDIAN_2={
  list:[
    {
      id:1,
      title:"Introduction to Agile & Scrum Framework",
      content:`Understand Agile principles, Scrum values, and the role of a Product Owner.`
    },
    {
      id:2,
      title:"Defining Product Vision & Strategy",
      content:`Craft a compelling product vision aligned with business goals and customer needs.`
    },
    {
      id:3,
      title:"Backlog Management & Prioritization",
      content:`Learn techniques like MoSCoW, Kano Model, and WSJF for effective prioritization.`
    },
    {
      id:4,
      title:"Stakeholder Engagement & Collaboration",
      content:`Develop skills to communicate with developers, executives, and customers effectively.`
    },
    {
      id:5,
      title:"Maximizing Business Value & ROI",
      content:`Understand how to measure success, define Key Performance Indicators (KPIs), and track Agile metrics.`
    },
    {
      id:6,
      title:"Scrum Events & Product Development Lifecycle",
      content:`Master Sprint Planning, Reviews, Retrospectives, and Incremental Product Releases.`
    },
    {
      id:7,
      title:"PSPO Exam Preparation & Best Practices",
      content:"Prepare for the Professional Scrum Product Owner (PSPO) certification exam with mock tests and case studies."
    }
  ],
  image:IMAGES.AGILE_ACCORDIAN_2,
  
}